const getAppointmentTypesSelectorType = (ageGroup)=>{
    const { forChildren , forAdults , forSeniors  } = ageGroup;
    if (forChildren && forAdults && forSeniors) {
        return 'children-adults-seniors-button-group';
    } else if (forChildren && forAdults && !forSeniors) {
        return 'children-adults-toggle';
    } else if (!forChildren && forAdults && forSeniors) {
        return 'seniors-adults-toggle';
    } else {
        // for all other cases we don't show any toggle
        return 'none';
    }
};

export { getAppointmentTypesSelectorType };
//# sourceMappingURL=get-appointment-types-selector-type.js.map
